mutation InvoiceBatchValidate($input: InvoiceBatchValidateInput!) {
  invoiceBatchValidate(input: $input) {
    invoiceBatches {
      id
      isVerified
      comment
      _rowTimestamp
      batchTransactionId
      invoiceId
      invoiceBatchTransactionType {
        transactionType
      }
      invoice {
        vendorReference
        invoiceNumber
        description
        invoiceDate
        _accountingStampTransactionReference
      }
      appliedAmount
      _isDeletable
    }
  }
}
